import LegalDocumentPage from "./LegalDocumentPage";

export default LegalDocumentPage